import { LoginResponse } from '@quadminds/client-apis/auth';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { getAuthService } from '../services/auth.service';

export function useCheckSession(options?: UseMutationOptions<LoginResponse, Error, void, unknown>) {
    return useMutation<LoginResponse, Error, void, unknown>({
        mutationFn: () => getAuthService().checkSession(),
        mutationKey: ['checkSession'],
        ...options,
    });
}

export default useCheckSession;
